exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".width8[data-v-65984c15]{width:80%}.width9[data-v-65984c15]{width:70%}.tempImgList[data-v-65984c15]{width:38px !important;height:30px !important;cursor:pointer;position:absolute;z-index:11}.tempImgList img[data-v-65984c15]{width:38px !important;height:30px !important}", ""]);

// exports
